import { FEATURE_FLAGS, isDevHost } from "../flags/index.js";

const originalConsoleLog = console.log;

let posthogInstance = null;
// Whatever console.log was when we silenced it, so restoring keeps wrappers added since load (session replay's).
let silencedFrom = null;

export const setPostHogInstance = (posthog) => {
  posthogInstance = posthog;

  try {
    applyConsoleOverrideBasedOnFlag();

    if (
      posthogInstance &&
      typeof posthogInstance.onFeatureFlags === "function"
    ) {
      posthogInstance.onFeatureFlags(() => {
        applyConsoleOverrideBasedOnFlag();
      });
    }
  } catch {
    restoreConsoleLog();
  }
};

const isConsoleLoggingEnabled = () => {
  // Without a PostHog key usePostHog still hands back the uninitialised client, whose flags all read as off.
  if (!posthogInstance?.__loaded || isDevHost()) {
    return true;
  }

  try {
    return posthogInstance.isFeatureEnabled(FEATURE_FLAGS.CONSOLE_LOGGING);
  } catch (error) {
    return true;
  }
};

const overriddenConsoleLog = (..._args) => {};

const applyConsoleOverrideBasedOnFlag = () => {
  if (isConsoleLoggingEnabled()) {
    restoreConsoleLog();
  } else if (!silencedFrom) {
    silencedFrom = console.log;
    console.log = overriddenConsoleLog;
  }
};

export const initializeConsoleOverride = () => {
  restoreConsoleLog();
};

export const restoreConsoleLog = () => {
  if (!silencedFrom) return;
  console.log = silencedFrom;
  silencedFrom = null;
};

export { originalConsoleLog };
